import Vue from 'vue'
import Vuex, { Commit, Dispatch } from 'vuex'

import snacks, { State as SnackState } from './modules/snack'

import user, { State as UserState } from './modules/user'

import app, { State as appState } from './modules/app'

import recordType, { State as RecordTypeState } from './modules/recordType'

import theCase, { State as CaseState } from './modules/case'

import page, { PageState } from './modules/page'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    snacks,
    user,
    app,
    recordType,
    theCase,
    page
  }
})

export interface ActionContextBasic {
  commit: Commit,
  dispatch: Dispatch
}

export interface State {
  snacks: SnackState,
  user: UserState,
  app: appState,
  recordType: RecordTypeState,
  theCase: CaseState,
  page: PageState
}
